module.exports = __webpack_public_path__ + "media/images/landing-pages/lp-sec-crs-2-22a49fecc97ed8e9404b5cb6be3d4bb4.png";